import useApiQuery from 'shared/hooks/use-api-query';
import {BaseAdditionalProps} from '../types';

const useBaseAdditionalsSelect = () => {
  const {data = [], ...rest} = useApiQuery<BaseAdditionalProps[]>({
    url: '/base-additionals/all',
  });

  return {
    ...rest,
    data: data?.map((baseAdditional) => ({
      label: baseAdditional.name,
      value: baseAdditional.id,
      data: baseAdditional,
    })),
  };
};

export default useBaseAdditionalsSelect;
